import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {finalize, Observable} from 'rxjs';
import {LoadingSpinnerCounterService} from '../services/loading-spinner-counter.service';

@Injectable({
  providedIn: 'root',
})
export class LoadingSpinnerInterceptor implements HttpInterceptor {
  readonly API_PATTERN_REGEX = /.*\/api\/.*/;
  readonly REPORTING_PATTERN_REGEX = /jasperserver/i;

  // Todo: Will be removed once backend details are fetched from backend
  readonly API_ALULA_HEALTH_PATTERN_REGEX = /https:\/\/api\.alula\.health\/.*/i;

  constructor(private loadingSpinnerCounterService: LoadingSpinnerCounterService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.isValidApiRequest(request.url)) {
      this.loadingSpinnerCounterService.incrementBusyCounter();
    }
    return next.handle(request)
      .pipe(
        finalize(() => {
          if (this.isValidApiRequest(request.url)) {
            this.loadingSpinnerCounterService.decrementBusyCounter();
          }
        })
      );
  }

  private isValidApiRequest(url: string): boolean {
    return (
      this.API_PATTERN_REGEX.test(url) ||
      this.REPORTING_PATTERN_REGEX.test(url) ||
      this.API_ALULA_HEALTH_PATTERN_REGEX.test(url)
    );
  }
}
